import { createFileRoute } from "@tanstack/react-router";
import { Playground } from "@/fla/Playground";
import { AppHeader } from "@/components/wb/AppHeader";

type PlaygroundSearch = {
  batches?: string[];
  parameterNames?: string[];
};

export const Route = createFileRoute("/_app/fla/playground")({
  validateSearch: (search: Record<string, unknown>): PlaygroundSearch => {
    return {
      batches: search?.batches as string[] | undefined,
      parameterNames: search?.parameterNames as string[] | undefined,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <AppHeader names={[{ name: "Playground" }]} />
      <Playground />
    </>
  );
}
